import { Checkbox, Tooltip, TooltipContent, TooltipTrigger } from '@leadsnavi/ui-kit';
import FactorIcon from '@/assets/icons/factor.svg?react';
import FactorImage from '../../images/factor-bg.png';
import BadgecheckIcon from '@/assets/icons/badgeCheck.svg?react';
import Query1Icon from '@/assets/icons/query1.svg?react';
import ShieldCheckIcon from '@/assets/icons/shield-check.svg?react';

/**
 * 云工厂服务卡片组件props
 */
/**
 * 云工厂服务卡片组件
 * @param param0
 * @returns
 */
export const ExpertServiceCard = () => {
  return (
    <div className="bg-gradient-to-r from-[#F9EDDC80]  to-[#E3CEAB80] rounded-lg px-4  h-[58px]   relative">
      <img src={FactorImage} className="absolute h-full left-[40%]" />
      <div className="px-4 flex justify-between absolute top-0 left-0 size-full">
        <div className="flex  items-center gap-4">
          <Checkbox disabled checked={true} />
          <div className="flex-1">
            <h3 className="text-sm font-medium text-[#09090B] mb-1 flex items-center gap-1">
              EaseSourcer Service
              <BadgecheckIcon />
              <Tooltip>
                <TooltipTrigger asChild>
                  <div>
                    <Query1Icon className="" />
                  </div>
                </TooltipTrigger>
                <TooltipContent className="max-w-[315px]">
                  <p>
                    ProLink is our human expert sourcing service. After you submit a sourcing inquiry, our experts
                    conduct in-depth research through proprietary channels across a vetted network of 60,000+ suppliers,
                    shortlist the best-fit partners, and facilitate direct responses from interested suppliers.
                  </p>
                </TooltipContent>
              </Tooltip>
            </h3>
            <p className="text-xs text-[#331E05] flex items-center ">
              Expert-led sourcing with our premium suppliers, handled end to end.
            </p>
          </div>
        </div>
        <div className="inline-flex  items-center justify-center">
          <div className="bg-[#171717] w-[1px] h-8 opacity-10 mr-3"></div>
          <ShieldCheckIcon />
          <div className="text-[#331E05]   text-xs ml-1">100% manual review</div>
          <FactorIcon className="ml-[17px]" />
        </div>
      </div>
    </div>
  );
};
